import { TOM_CRITICAL_REPORT_TYPES, TOM_WARNING_REPORT_TYPES } from "../constants"

export const getReportSeverity = (reportType, status) => {
    const notProcessed = ["not_processed", "ai_processed"].includes(status);
    if (Object.keys(TOM_CRITICAL_REPORT_TYPES).includes(reportType)) {
        return "critical"
    }
    if (Object.keys(TOM_WARNING_REPORT_TYPES).includes(reportType)) {
        return "warning"
    }

    if (reportType === null && !notProcessed) {
        return "ok"
    }

    if (!reportType) {
        return null
    }

    return null
}